import React from "react";

const CloseBigVideo = () => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.27052 0L3.09131 1.66233C3.34251 1.54864 3.62139 1.48535 3.91505 1.48535H19.9151C21.0196 1.48535 21.9151 2.38078 21.9151 3.48535V13.4854C21.9151 14.5899 21.0196 15.4854 19.9151 15.4854H18.2319L23.4507 20.2499L22.1802 21.6416L0 1.39163L1.27052 0ZM1.91505 5.62407V13.4854C1.91505 14.5899 2.81048 15.4854 3.91505 15.4854H12.7163L8.25483 11.4121C6.64319 12.1937 5.33865 13.0244 4.91505 13.4854C4.91505 12.0087 5.62067 10.8606 6.66637 9.96191L1.91505 5.62407ZM14.5043 17.1178C13.6002 16.9959 12.759 16.9336 11.9152 16.9336C9.40551 16.9336 6.91946 17.4847 2.7292 18.5142L3.20638 20.4564C7.43717 19.417 9.68796 18.9336 11.9151 18.9336C13.4745 18.9336 15.0454 19.1706 17.2992 19.6694L14.5043 17.1178ZM10.1033 8.06415L12.1353 9.91928C13.1704 9.63832 14.1632 9.48378 14.9951 9.54229V12.1043L19.9151 7.79484L14.9951 3.48535V6.71747C14.7746 6.77666 14.4793 6.84444 14.1284 6.92497L14.1283 6.92498L14.1283 6.92498C13.1014 7.16065 11.5985 7.50553 10.1033 8.06415Z"
        fill="#f20000"
      />
    </svg>
  );
};

export default CloseBigVideo;
